import React from 'react';
import PropTypes from 'prop-types';
import { TextArea, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import Recaptcha from '../Recaptcha';
import { noop } from '../../../lib/utils';
import styles from './SubmitReview.module.css';

const cx = classnames.bind(styles);

export default function WriteReview({
  submitError,
  onReviewChange,
  onRecaptchaVerified,
  onRecaptchaExpired,
  renderRecaptcha,
}) {
  return (
    <React.Fragment>
      <Text>Write a short review</Text>
      <br />
      <br />
      <TextArea
        className={cx('textarea')}
        autoHeight
        placeholder="Tell us what you think"
        onChange={onReviewChange}
      />
      {renderRecaptcha && (
        <Recaptcha
          elementID="writeReviewRecaptcha"
          verifyCallback={onRecaptchaVerified}
          expiredCallback={onRecaptchaExpired}
        />
      )}
      {!!submitError && (
        <Text as="p" color="orange">
          {submitError}
        </Text>
      )}
    </React.Fragment>
  );
}

WriteReview.propTypes = {
  submitError: PropTypes.string,
  onReviewChange: PropTypes.func,
  onRecaptchaVerified: PropTypes.func,
  onRecaptchaExpired: PropTypes.func,
  renderRecaptcha: PropTypes.bool,
};

WriteReview.defaultProps = {
  submitError: undefined,
  onReviewChange: noop,
  onRecaptchaVerified: noop,
  onRecaptchaExpired: noop,
  renderRecaptcha: false,
};
